// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-79.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-79.use[2]!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-79.use[3]!../../node_modules/stylus-loader/dist/cjs.js??clonedRuleSet-79.use[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./CourseCard.vue?vue&type=style&index=0&id=a38acb88&prod&lang=stylus&");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add CSS to Shadow Root
var add = require("!../../node_modules/vue-style-loader/lib/addStylesShadow.js").default
module.exports.__inject__ = function (shadowRoot) {
  add("1b7c0658", content, shadowRoot)
};